<script setup lang="ts">
interface Props {
  show: boolean
  title?: string
  size?: 'sm' | 'md' | 'lg'
}

withDefaults(defineProps<Props>(), {
  title: '',
  size: 'md',
})

const emit = defineEmits<{
  close: []
}>()

const sizeClasses: Record<string, string> = {
  sm: 'max-w-[400px]',
  md: 'max-w-[600px]',
  lg: 'max-w-[800px]',
}

function onOverlayClick(event: MouseEvent) {
  if (event.target === event.currentTarget) {
    emit('close')
  }
}
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
        @click="onOverlayClick"
      >
        <Transition name="slide-up" appear>
          <div
            v-if="show"
            :class="[
              'w-full mx-4 bg-sf-bg-secondary border border-sf-border rounded-[24px] shadow-2xl',
              sizeClasses[size],
            ]"
          >
            <!-- Header -->
            <div
              v-if="title"
              class="flex items-center justify-between px-8 py-6 border-b border-sf-border"
            >
              <h2 class="text-lg font-semibold text-sf-text-primary">{{ title }}</h2>
              <button
                class="flex items-center justify-center w-8 h-8 rounded-lg text-sf-text-muted hover:text-sf-text-primary hover:bg-sf-bg-tertiary transition-colors"
                @click="emit('close')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <!-- Body -->
            <div class="px-8 py-6">
              <slot />
            </div>

            <!-- Footer -->
            <div
              v-if="$slots.footer"
              class="flex items-center justify-end gap-3 px-8 py-6 border-t border-sf-border"
            >
              <slot name="footer" />
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>
